import React, { useState, useRef, useEffect } from 'react';
import { User, LogOut, ChevronDown } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

export default function Topbar() {
  const { user, logout } = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('touchstart', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside);
    };
  }, []);

  return (
    <header className="flex items-center justify-between px-4 md:px-6 py-0 bg-white border-b border-gray-100 sticky top-0 z-30 shrink-0 h-[60px] shadow-sm">
      {/* Logo */}
      <div className="flex items-center gap-2.5 shrink-0">
        <div className="w-9 h-9 bg-gradient-to-br from-blue-500 to-blue-700 rounded-full flex items-center justify-center text-white font-extrabold text-base shadow-sm shrink-0">
          K
        </div>
        <span className="text-lg font-extrabold text-gray-900 tracking-tight">
          Katabo
        </span>
      </div>

      {/* Spacer */}
      <div className="flex-1" />

      {/* User avatar / profile with dropdown */}
      <div className="relative flex items-center shrink-0" ref={menuRef}>
        <button
          onClick={() => setMenuOpen(prev => !prev)}
          className="flex items-center gap-2 px-2 py-1.5 rounded-full hover:bg-gray-100 active:bg-gray-200 transition-colors"
        >
          <div className="w-8 h-8 rounded-full bg-blue-100 flex items-center justify-center">
            <User className="w-4 h-4 text-blue-600" />
          </div>
          {user?.phone && (
            <span className="hidden sm:block text-sm font-medium text-gray-600 max-w-[120px] truncate">
              {user.phone}
            </span>
          )}
          <ChevronDown className={`w-4 h-4 text-gray-400 transition-transform duration-200 ${menuOpen ? 'rotate-180' : ''}`} />
        </button>

        {/* Dropdown */}
        {menuOpen && (
          <div className="absolute right-0 top-full mt-2 w-56 bg-white rounded-2xl shadow-xl border border-gray-100 py-2 z-50 animate-fade-in-up">
            {/* User info row */}
            <div className="px-4 py-3 border-b border-gray-100">
              <div className="flex items-center gap-3">
                <div className="w-9 h-9 rounded-full bg-blue-100 flex items-center justify-center shrink-0">
                  <User className="w-4 h-4 text-blue-600" />
                </div>
                <div className="min-w-0">
                  <p className="text-xs text-gray-400 font-medium">Logged in as</p>
                  <p className="text-sm font-bold text-gray-800 truncate">{user?.phone}</p>
                </div>
              </div>
            </div>

            {/* Logout button */}
            <button
              onClick={() => { setMenuOpen(false); logout(); }}
              className="w-full flex items-center gap-3 px-4 py-3 text-sm font-medium text-red-600 hover:bg-red-50 active:bg-red-100 transition-colors"
            >
              <LogOut className="w-4 h-4 shrink-0" />
              Logout
            </button>
          </div>
        )}
      </div>
    </header>
  );
}
